import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook personalizado para limpiar localStorage "entradas"
 * Solo debe existir en la página de checkout /pagar o /checkout
 * Se elimina automáticamente en todas las demás rutas
 */
export const useCleanupLocalStorage = () => {
  const location = useLocation();

  useEffect(() => {
    // Definir rutas donde el localStorage "entradas" DEBE permanecer
    const allowedRoutes = ['/pagar', '/checkout'];

    // Verificar si la ruta actual NO está en las rutas permitidas
    const shouldCleanup = !allowedRoutes.some(route =>
      location.pathname.includes(route)
    );

    if (shouldCleanup) {
      // Limpiar localStorage si no estamos en una ruta permitida
      const hasEntradas = localStorage.getItem('entradas');
      if (hasEntradas) {
        console.log(`🧹 Limpiando localStorage "entradas" en ruta: ${location.pathname}`);
        localStorage.removeItem('entradas');
      }
    }
  }, [location.pathname]);
};
